
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class ShapeFilterDialog extends Serenity.PropertyDialog<any, any>
    {

        protected form = new ShapeFilterForm(this.idPrefix);

        public shapegroup1: string[];
        public shapegroup2: string[];
        public checksuccess: boolean;
        constructor() {
            super();
            this.form = new ShapeFilterForm(this.idPrefix);
        }

        protected getDialogTitle(): string {
            return "Shape Groups";
        }

        protected onDialogOpen() {
            super.onDialogOpen();
             
        }


        protected getDialogButtons() {
            return [
                {
                    text: 'Ok',
                    click: () => {
                        if (!this.validateBeforeSave())
                            return;
                        var shapefilter1 = this.form.ShapeFilter1.values;
                        var shapefilter2 = this.form.ShapeFilter2.values; 
                        var commonshapes = [];
                        for (var i = 0; i < shapefilter1.length; i++) {
                            var shape1 = shapefilter1[i];
                            for (var j = 0; j < shapefilter2.length; j++) {
                                var shape2 = shapefilter2[j];
                                if (shape1 == shape2) {
                                    commonshapes.push(shape1);
                                }
                            }
                        }
                        if (commonshapes.length > 0) {
                            q.alert('', 'Common Shapes found in both groups', true, 3000);
                            return;
                        }

                        this.checksuccess = true;

                        this.shapegroup1 = shapefilter1;
                        this.shapegroup2 = shapefilter2;
                        this.dialogClose();
                    },
                },
                {
                    text: 'Cancel',
                    click: () => {
                        this.checksuccess = false;
                        this.dialogClose();

                    }
                }
            ];
        }
    }
}